<template>

  <div class="time-duration" :class="{'red-text': redTextColor}">

    <div :class="['time-duration__value', {'table-cell': showTooltip }]"
         v-tooltip.bottom="{ content: durationTooltip, html: false, autoHide: false }"
    >

      <span v-if="!formattedDisplay" data-test="time-duration.value_string">{{ durationString }}</span>

      <span v-else
            v-for="(time, index) in formattedDuration.timeUnits"
            class="time-duration-display"
      >

        <label class="time-duration__value__time-value" :data-test="`time-duration.${index}_value`">
          {{ time.value }}
        </label>

        <label class="time-duration__value__time-unit" :data-test="`time-duration.${index}_unit`">
          {{ time.unit }}
        </label>

      </span>

    </div>

  </div>

</template>

<script>
  import durationFilter from '@core/filters/duration';

  export default {
    name: 'time-duration',
    components: {},
    data() {
      return {
        intervalId: null,
      };
    },
    props: {
      duration: {
        type: Number,
        required: true,
      },
      showTooltip: {
        type: Boolean,
        required: false,
        default: true,
      },
      tooltip: {
        type: String,
        required: false,
      },
      redTextColor: {
        type: Boolean,
        required: false,
        default: false,
      },
      extendedLogic: {
        type: Boolean,
        default: false,
      },
      formattedDisplay: {
        type: Boolean,
        default: false,
      },
    },
    filters: {
      durationFilter,
    },
    methods: {},
    computed: {
      formattedDuration() {
        return durationFilter(this.duration, '', this.extendedLogic);
      },
      durationString() {
        const formattedDuration = this.formattedDuration;
        let result = '';
        if (formattedDuration) {
          result = `${formattedDuration.overdueSign}
        ${formattedDuration.timeUnits[0].value}${formattedDuration.timeUnits[0].unit}
        ${formattedDuration.timeUnits[1].value}${formattedDuration.timeUnits[1].unit}`;
        }
        return result;
      },
      durationTooltip() {
        return this.showTooltip ? durationFilter(this.duration, 'long') : '';
      },
    },
  };
</script>

<style lang="scss">
  .red-text {
    @include themify {
      color: getColor('error', 'amd');
    }
  }

  .time-duration {
    &__value {
      display: inline;

      &.table-cell {
        display: table-cell;
      }

      &__time-value {
        font-size: $font-size-xxxx-large;
        font-weight: bold;
      }

      &__time-unit {
        font-size: $font-size-xx-large-intermediate;
      }
    }
  }

  .time-duration .time-duration-display {
    display: inline-flex;
    align-items: baseline;
    padding-right: 6px;
  }

</style>
